export default __webpack_public_path__ + "static/media/Roboto-Thin.59115760.ttf";